"use strict";
(() => {
  // website/assets/dd-cube-shop-start.mjs
  function mountCubeShopStartGuard({ document: document2, prepare, ready = () => false }) {
    let busy = false, disposed = false;
    const listener = async (event) => {
      const button = event.target?.closest?.("button");
      if (!button || !["start", "again", "again2", "again4"].includes(button.id) || !document2.getElementById("cuberun")?.contains(button)) return;
      if (ready()) {
        document2.getElementById("dd-cube-shop-start-status")?.remove();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || disposed) return;
      busy = true;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      let ok = false;
      try {
        ok = await prepare() === true;
      } catch {
      }
      const current = document2.getElementById(button.id) || button;
      button.disabled = false;
      button.removeAttribute("aria-busy");
      current.disabled = false;
      busy = false;
      if (disposed) return;
      let status = document2.getElementById("dd-cube-shop-start-status");
      if (!status) {
        status = document2.createElement("p");
        status.id = "dd-cube-shop-start-status";
        status.setAttribute("role", "status");
        current.after(status);
      }
      status.textContent = ok ? document2.getElementById("app")?.lang === "ar" ? "\u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629 \u062C\u0627\u0647\u0632\u0629. \u0627\u0636\u063A\u0637\u0648\u0627 \u0644\u0644\u0628\u062F\u0621." : "Your reward is ready. Tap to start." : document2.getElementById("app")?.lang === "ar" ? "\u062A\u0639\u0630\u0651\u0631 \u062A\u062C\u0647\u064A\u0632 \u0645\u0643\u0627\u0641\u0623\u062A\u0643\u0645. \u0627\u0636\u063A\u0637\u0648\u0627 \u0644\u0644\u0628\u062F\u0621 \u0645\u0631\u0651\u0629 \u0623\u062E\u0631\u0649." : "We could not prepare your reward. Please tap to start again.";
    };
    document2.addEventListener("click", listener, true);
    return { dispose() {
      disposed = true;
      document2.removeEventListener("click", listener, true);
    } };
  }

  // website/assets/dd-cube-shop.mjs
  var isCubeShopPage = ({ pathname, experience }) => experience === "shop" && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/wooden-alphabet-cubes\/?$/i.test(pathname || "");
  function createCubeShopTransport({ fetch: send, storage, base = "/apps/dardasha-digital/" }) {
    const key = "dd-cube-shop-session-v1";
    let profileRequest = null;
    const read = () => {
      try {
        return storage.getItem(key) || void 0;
      } catch {
        return void 0;
      }
    };
    const post = (endpoint, body, signal) => send(base + "cube/shop/" + endpoint, { method: "POST", credentials: "same-origin", cache: "no-store", redirect: "error", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body), signal });
    return async (url, init = {}) => {
      if (url === base + "profile") {
        if (!profileRequest) {
          profileRequest = (async () => {
            const r = await post("profile", { sessionToken: read() }, init.signal);
            const b = await r.clone().json();
            if (r.ok) {
              if (!/^g1\.\d{13}\.[a-f0-9-]{36}\.[a-f0-9]{64}$/.test(b.sessionToken || "") || !/^[a-f0-9]{64}$/.test(b.accountScope || "")) throw Error("Unverified Shop session");
              storage.setItem(key, b.sessionToken);
              storage.setItem("dd-cube-session-v1", b.sessionToken);
              storage.setItem("dd-cube-shop-scope-v1", b.accountScope);
            }
            return r;
          })().finally(() => {
            profileRequest = null;
          });
        }
        return (await profileRequest).clone();
      }
      const endpoint = url.startsWith(base + "cube/") ? url.slice((base + "cube/").length) : null;
      if (endpoint && ["session", "challenge", "complete", "checkout", "gift-notice"].includes(endpoint)) {
        const body = JSON.parse(init.body || "{}");
        return post(endpoint, { ...body, sessionToken: read() }, init.signal);
      }
      return send(url, init);
    };
  }
  function cubeShopStorage(storage) {
    return { getItem: (k) => storage.getItem("dd-shop:" + k), setItem: (k, v) => storage.setItem("dd-shop:" + k, v), removeItem: (k) => storage.removeItem("dd-shop:" + k) };
  }

  // website/assets/dd-cube-shop-cart.mjs
  function createCubeCartNoticeTransport(send, storage) {
    const shopStorage = cubeShopStorage(storage), shopSend = createCubeShopTransport({ fetch: send, storage: shopStorage });
    let guest = false;
    return async (url, init) => {
      if (url.endsWith("cart.js")) {
        const r = await send(url, init);
        try {
          const b = await r.clone().json(), scope = shopStorage.getItem("dd-cube-shop-scope-v1");
          guest = /^[a-f0-9]{64}$/.test(scope || "") && b.items?.some((i) => /^[a-f0-9-]{36}$/i.test(i.properties?._dd_cube_claim || "") && storage.getItem(`dd-cube-cart:${scope}:${i.properties._dd_cube_claim}`));
        } catch {
          guest = false;
        }
        return r;
      }
      return guest ? shopSend(url, init) : send(url, init);
    };
  }

  // website/assets/dd-cube-compat.css
  var dd_cube_compat_default = "/* Website compatibility for the embedded, unmodified Cube Run pack.\r\n * Theme empty-div rules must not hide decorative gift pieces.\r\n * The product gift card must keep the same grid as the cubes card.\r\n */\r\n#cuberun #box > .box,\r\n#cuberun #box .bow { display: block; }\r\n#cuberun .product.gift {\r\n  display: grid;\r\n  position: static;\r\n  height: auto;\r\n  margin-top: 0;\r\n  cursor: auto;\r\n}\r\n#cuberun .product.gift > div { min-width: 0; }\r\n\r\n/* Dawn cards fill their parent height. Game overlay cards must size to content\r\n * or the engine ResizeObserver grows the stage by its own padding on each pass. */\r\n#cuberun .overlay > .card { height: auto; min-height: 0; }\r\n";

  // website/assets/dd-cube-cart-gift.css
  var dd_cube_cart_gift_default = "[data-dd-cube-gift-row][hidden],.dd-cube-included-gift[hidden]{display:none!important}\n[data-dd-cube-gift-row]>td{padding:0 0 28px!important;border:0!important}\n.dd-cube-included-gift{display:flex;align-items:center;gap:17px;max-width:660px;padding:16px 18px;margin:0;background:#faf7ff;border:1px solid #e6ddef;border-radius:14px;color:#252329;font:inherit;box-sizing:border-box}\n.dd-cube-included-gift img{width:75px;height:75px;object-fit:contain;flex-shrink:0;background:#fff;border-radius:10px}\n.dd-cube-gift-copy{flex:1;min-width:0}.dd-cube-included-gift p{margin:0!important;font:inherit;letter-spacing:normal}\n.dd-cube-included-gift .dd-cube-gift-title{color:#7658a8;font-size:12px;margin-bottom:8px!important}\n.dd-cube-included-gift .dd-cube-gift-text{font-size:14px;line-height:1.65}\n.dd-cube-included-gift .dd-cube-gift-sub{font-size:11px;color:#68616f;line-height:1.6;margin-top:8px!important}\n.dd-cube-gift-included{color:#7658a8;white-space:nowrap;font-size:12px}\n@media(max-width:749px){[data-dd-cube-gift-row]{display:block!important}[data-dd-cube-gift-row][hidden]{display:none!important}[data-dd-cube-gift-row]>td{display:block;width:100%;padding-bottom:20px!important}.dd-cube-included-gift{padding:13px;gap:12px;max-width:100%}.dd-cube-included-gift img{width:59px;height:65px}.dd-cube-included-gift .dd-cube-gift-text{font-size:12px}.dd-cube-gift-included{display:none}}\n.dd-cube-included-gift p{font-family:inherit!important}\r\n";

  // website/assets/dd-cube-cart-notice.mjs
  var uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  async function refreshCubeCartNotice({ node, fetch: send, root = "/", now = Date.now }) {
    node.hidden = true;
    node.textContent = "";
    if (!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(root)) return;
    const read = async (url) => {
      const r = await send(url, { credentials: "same-origin", cache: "no-store", redirect: "error" });
      if (!r.ok) throw Error("unavailable");
      return r.json();
    };
    try {
      const cart = await read(root + "cart.js");
      if (!Array.isArray(cart.items) || cart.items.length > 1e3) return;
      const lines = cart.items.filter((i) => uuid.test(i.properties?._dd_cube_claim || "") && i.quantity === 1 && !i.selling_plan_allocation);
      const inputs = lines.map((i) => ({ claimId: i.properties._dd_cube_claim, allocation: (i.line_level_discount_allocations || []).find((a) => a.amount > 0 && a.discount_application?.type === "discount_code" && a.discount_application?.value_type === "percentage" && Number(a.discount_application.value) === 20) })).filter((i) => i.allocation);
      if (!inputs.length || inputs.length > 5 || new Set(inputs.map((i) => i.claimId)).size !== inputs.length) return;
      const profile = await read("/apps/dardasha-digital/profile");
      if (!(profile.authenticated || profile.cubeRun?.guestCheckout === true) || !profile.cubeRun?.commerceEnabled || !profile.cubeRun.checkoutToken) return;
      const response = await send("/apps/dardasha-digital/cube/gift-notice", { method: "POST", credentials: "same-origin", cache: "no-store", redirect: "error", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token: profile.cubeRun.checkoutToken, items: inputs.map((i) => ({ claimId: i.claimId, discountTitle: i.allocation.discount_application.title })) }) });
      if (!response.ok) return;
      const result = await response.json();
      if (result.accountScope !== profile.accountScope || !Array.isArray(result.items)) return;
      const [fresh, current] = await Promise.all([read("/apps/dardasha-digital/profile"), read(root + "cart.js")]);
      if (!(fresh.authenticated || fresh.cubeRun?.guestCheckout === true) || !fresh.cubeRun?.commerceEnabled || fresh.accountScope !== profile.accountScope || !Array.isArray(current.items)) return;
      const valid = result.items.find((g) => g.status === "reserved" && Date.parse(g.expiresAt) > now() && current.items.filter((i) => i.properties?._dd_cube_claim === g.claimId).length === 1 && current.items.some((i) => i.properties?._dd_cube_claim === g.claimId && i.quantity === 1 && String(i.variant_id) === String(g.variantId) && !i.selling_plan_allocation && (i.line_level_discount_allocations || []).some((a) => a.amount > 0 && a.discount_application?.title === inputs.find((x) => x.claimId === g.claimId)?.allocation.discount_application.title && a.discount_application?.value_type === "percentage" && Number(a.discount_application.value) === g.pct)));
      if (!valid) return;
      node.textContent = node.dataset.lang?.startsWith("ar") ? "\u062D\u064F\u062C\u0650\u0632\u062A \u0644\u0643\u0645 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u062C\u0633\u0651\u0645\u0627\u062A \u0645\u062C\u0627\u0646\u064A\u0651\u0629. \u0633\u062A\u064F\u0631\u0641\u064E\u0642 \u0628\u0637\u0644\u0628\u0643\u0645 \u0628\u0639\u062F \u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647." : "A free figurines set is reserved. It will be included after your qualifying order is paid and confirmed.";
      node.hidden = false;
      return { expiresAt: valid.expiresAt, variantId: valid.variantId, lineIndex: current.items.findIndex((i) => i.properties?._dd_cube_claim === valid.claimId) };
    } catch {
    }
  }

  // website/assets/dd-cube-cart-gift.mjs
  function renderCubeCartGift({ document: document2, node, variantId, lineIndex }) {
    if (!Number.isSafeInteger(variantId) || variantId < 1 || !Number.isInteger(lineIndex) || lineIndex < 0) return false;
    const anchor = document2.getElementById(`CartItem-${lineIndex + 1}`);
    if (!anchor || !Array.from(anchor.querySelectorAll("a[href]")).some((a) => {
      try {
        return new URL(a.href).searchParams.get("variant") === String(variantId);
      } catch {
        return false;
      }
    })) return false;
    let row = document2.querySelector("[data-dd-cube-gift-row]");
    if (!row) {
      row = document2.createElement("tr");
      row.dataset.ddCubeGiftRow = "";
      const cell = document2.createElement("td");
      cell.colSpan = 4;
      row.append(cell);
    }
    const ar = node.dataset.lang?.startsWith("ar");
    const image = document2.createElement("img");
    image.src = "https://cdn.shopify.com/s/files/1/0537/3421/1752/files/dardashatoy3copy.jpg?v=1707460140&width=200";
    image.alt = ar ? "\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062C\u0633\u0651\u0645\u0627\u062A \u0627\u0644\u062E\u0634\u0628\u064A\u0651\u0629" : "Wooden figurines set";
    image.width = 75;
    image.height = 75;
    const copy = document2.createElement("div");
    copy.className = "dd-cube-gift-copy";
    for (const [className, text] of [
      ["dd-cube-gift-title", ar ? "\u0647\u062F\u064A\u0651\u062A\u0643\u0645 \u0645\u0646 Cube Run" : "YOUR CUBE RUN GIFT"],
      ["dd-cube-gift-text", ar ? "\u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u062C\u0633\u0651\u0645\u0627\u062A \u062E\u0634\u0628\u064A\u0651\u0629 \u0645\u062C\u0627\u0646\u064A\u0651\u0629 \u0645\u0639 \u0637\u0644\u0628\u0643\u0645" : "Free wooden figurines set included"],
      ["dd-cube-gift-sub", ar ? "\u0633\u0646\u064F\u0631\u0641\u0642 \u0645\u062C\u0645\u0648\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u0639 \u0637\u0644\u0628 \u0645\u0643\u0639\u0651\u0628\u0627\u062A\u0643\u0645." : "We\u2019ll pack one set with your Cubes order."]
    ]) {
      const p = document2.createElement("p");
      p.className = className;
      p.textContent = text;
      copy.append(p);
    }
    const extra = document2.createElement("span");
    extra.className = "dd-cube-gift-included";
    extra.textContent = ar ? "\u0647\u062F\u064A\u0651\u0629 \u0645\u0646\u0651\u0627!" : "On us!";
    node.className = "dd-cube-included-gift";
    node.removeAttribute("style");
    node.dir = ar ? "rtl" : "ltr";
    node.replaceChildren(image, copy, extra);
    row.firstElementChild.append(node);
    anchor.after(row);
    row.hidden = false;
    node.hidden = false;
    return true;
  }
  function mountCubeCartGift({ document: document2, target, node, fetch: send, MutationObserver, setTimeout: schedule, clearTimeout: cancel, css = "", now = Date.now }) {
    const style = document2.createElement("style");
    style.textContent = css;
    document2.head.append(style);
    let generation = 0, timer, disposed = false;
    const hide = () => {
      node.hidden = true;
      const row = document2.querySelector("[data-dd-cube-gift-row]");
      if (row) row.hidden = true;
    };
    const refresh = () => {
      if (disposed) return;
      const own = ++generation;
      cancel(timer);
      hide();
      const proxy = { dataset: node.dataset, set hidden(_v) {
      }, set textContent(_v) {
      } };
      void refreshCubeCartNotice({ node: proxy, fetch: send, root: node.dataset.root || "/", now }).then((result) => {
        if (disposed || own !== generation || !result) return;
        if (Date.parse(result.expiresAt) <= now() || !renderCubeCartGift({ document: document2, node, ...result })) return;
        timer = schedule(() => {
          hide();
          refresh();
        }, Math.max(1, Math.min(3e4, Date.parse(result.expiresAt) - now())));
      }).catch(() => {
        if (own === generation) hide();
      });
    };
    const change = () => {
      hide();
      refresh();
    };
    const remove = (e) => {
      if (e.target.closest("cart-remove-button")) {
        ++generation;
        cancel(timer);
        hide();
        timer = schedule(refresh, 700);
      }
    };
    const observer = MutationObserver ? new MutationObserver((records) => {
      const changed = records.some((r) => [...r.addedNodes, ...r.removedNodes].some((n) => n.nodeType === 1 && (n.matches?.('tr[id^="CartItem-"]') || n.querySelector?.('tr[id^="CartItem-"]'))));
      if (changed) {
        ++generation;
        cancel(timer);
        hide();
        timer = schedule(refresh, 75);
      }
    }) : null;
    observer?.observe(document2.querySelector("#main-cart-items") || document2.body, { subtree: true, childList: true });
    target.addEventListener("pageshow", refresh);
    target.addEventListener("focus", refresh);
    document2.addEventListener("change", change);
    document2.addEventListener("click", remove);
    refresh();
    return { refresh, dispose() {
      disposed = true;
      ++generation;
      cancel(timer);
      observer?.disconnect();
      hide();
      style.remove();
      target.removeEventListener("pageshow", refresh);
      target.removeEventListener("focus", refresh);
      document2.removeEventListener("change", change);
      document2.removeEventListener("click", remove);
    } };
  }

  // website/assets/dd-cube-diagnostics.mjs
  var reasons = /* @__PURE__ */ new Map([
    ["Checked run required", "checked_run_missing"],
    ["Run is outside the pilot limits", "run_metrics_outside_limits"],
    ["Run timing could not be checked", "run_timing_rejected"],
    ["Invalid run evidence", "invalid_run_evidence"],
    ["Challenge not found", "challenge_not_found"],
    ["This run belongs to another account", "account_mismatch"],
    ["Challenge already used", "challenge_already_used"],
    ["Run already used", "run_already_used"],
    ["Reward pilot is not enabled", "pilot_unavailable"],
    ["Please wait before claiming another reward", "rate_limited"],
    ["Refresh your reward session", "session_expired"],
    ["Sign in to claim your reward", "sign_in_required"],
    ["Sign in to claim this reward", "sign_in_required"],
    ["Rewards are not configured", "configuration_missing"]
  ]);
  function diagnosticResponse(url, status, body) {
    const step = String(url).split("?")[0].match(/\/(profile|session|challenge|complete|checkout)$/)?.[1];
    if (!step) return null;
    return {
      step,
      status: Number.isInteger(status) ? status : 0,
      ...status >= 400 ? { reason: reasons.get(body?.error) || "request_rejected" } : {},
      ...step === "challenge" && status === 200 ? { challengeShapeValid: /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(body?.challengeId || ""), hasDeadline: Number.isFinite(Date.parse(body?.notBefore)), deadlineLeadMs: Number.isFinite(Date.parse(body?.notBefore)) ? Date.parse(body.notBefore) - Date.now() : null, hasExpiry: Number.isFinite(Date.parse(body?.expiresAt)) } : {}
    };
  }
  function diagnosticRun(history) {
    const events = Array.isArray(history) ? history : [];
    const start = [...events].reverse().find((e) => e.type === "run_started");
    if (!start) return { started: false };
    const completed = [...events].reverse().find((e) => e.type === "run_completed" && e.runId === start.runId);
    const metrics = {};
    for (const k of ["cubes", "activeSeconds", "bonusSeconds", "presses", "pauses", "roundSeconds", "maxBonusSeconds"]) {
      const v = completed?.metrics?.[k];
      if (typeof v === "number" && Number.isFinite(v)) metrics[k] = v;
    }
    return { started: true, challengeOnStart: !!start.challengeId, completed: !!completed, challengeOnCompletion: !!completed?.challengeId, ...completed ? { metrics } : {} };
  }
  function mountCubeDiagnostics({ document: document2, engine, enabled = false }) {
    if (!enabled || !engine) return { response() {
    }, profile() {
    }, dispose() {
    } };
    const host = document2.getElementById("cuberun");
    if (!host) return { response() {
    }, profile() {
    }, dispose() {
    } };
    const panel = document2.createElement("details"), summary = document2.createElement("summary"), text = document2.createElement("pre");
    panel.className = "dd-panel";
    panel.hidden = true;
    panel.dataset.ddCubeDiagnostics = "";
    summary.textContent = "Reward test diagnostics";
    text.style.whiteSpace = "pre-wrap";
    text.style.fontSize = "12px";
    panel.append(summary, text);
    host.after(panel);
    const responses = [];
    function render() {
      text.textContent = JSON.stringify({ run: diagnosticRun(engine.history?.() || []), responses }, null, 2);
    }
    return {
      response(url, status, body) {
        const row = diagnosticResponse(url, status, body);
        if (row) {
          responses.push(row);
          if (responses.length > 10) responses.shift();
          render();
        }
      },
      profile(p) {
        panel.hidden = !(p?.authenticated && p?.cubeRun?.commerceEnabled === true);
        render();
      },
      dispose() {
        panel.remove();
      }
    };
  }

  // website/assets/dd-cube-challenge.mjs
  var VERSION = "29.3-beta";
  var KEY = "dd-cube-pending-v1";
  var CLOCK_TOLERANCE = 5e3;
  var uuid2 = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  function minimal(event) {
    const m = event.metrics || {};
    if (event.gameVersion !== VERSION || !uuid2.test(event.challengeId || "") || !uuid2.test(event.runId || "")) return null;
    return {
      challengeId: event.challengeId,
      runId: event.runId,
      gameVersion: VERSION,
      metrics: Object.fromEntries(["cubes", "activeSeconds", "bonusSeconds", "presses", "pauses", "roundSeconds", "maxBonusSeconds"].map((k) => [k, m[k]]))
    };
  }
  function createCubeChallengeBridge({ engine, identity, request, storage, uid = () => crypto.randomUUID(), now = () => Date.now(), wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)), notify = () => {
  } }) {
    let generation = 0, candidate = null, running = null, pending = null, inflight = null, disposed = false;
    let scope = identity()?.accountScope ?? null;
    const clearSaved = () => {
      try {
        storage?.removeItem(KEY);
      } catch {
      }
    };
    const save = () => {
      try {
        pending ? storage?.setItem(KEY, JSON.stringify(pending)) : clearSaved();
      } catch {
      }
    };
    try {
      const saved = JSON.parse(storage?.getItem(KEY) || "null");
      if (saved && saved.expiresAt > now() && saved.expiresAt <= now() + 15 * 6e4 && minimal(saved.evidence) && Number.isFinite(saved.notBefore) && saved.notBefore <= now() + 45e3 + CLOCK_TOLERANCE && (saved.owner === null || saved.owner === scope)) pending = { ...saved, evidence: minimal(saved.evidence) };
      else clearSaved();
    } catch {
      clearSaved();
    }
    const enabled = (i) => i?.cubeRun?.challengeEnabled === true && i.cubeRun.gameVersion === VERSION && typeof i.cubeRun.token === "string";
    const same = (version, owner) => !disposed && generation === version && (identity()?.accountScope ?? null) === owner;
    async function issue({ forPlay = false } = {}) {
      const i = identity();
      if (disposed || !enabled(i)) return;
      const owner = i.accountScope;
      if (forPlay && candidate && candidate.owner === owner && candidate.expiresAt > now() + 18e4 && engine.setChallenge(candidate.id) !== false) return;
      const version = ++generation, before = engine.state();
      if (!(forPlay ? ["title", "results", "shop", "cart"] : ["title", "results"]).includes(before.screen)) return;
      candidate = null;
      engine.setChallenge(null);
      try {
        const result = await request("challenge", { token: i.cubeRun.token, requestId: uid(), gameVersion: VERSION });
        const after = engine.state();
        if (!same(version, owner) || after.screen !== before.screen || after.runId !== before.runId) return;
        const notBefore = Date.parse(result.notBefore);
        if (!uuid2.test(result.challengeId || "") || result.gameVersion !== VERSION || !Number.isFinite(Date.parse(result.expiresAt)) || Date.parse(result.expiresAt) <= now() || !Number.isFinite(notBefore) || notBefore > now() + 45e3 + CLOCK_TOLERANCE) throw Error("invalid_challenge");
        if (engine.setChallenge(result.challengeId) === false) throw Error("challenge_rejected");
        candidate = { id: result.challengeId, owner: i.authenticated || i.cubeRun?.guestCheckout === true ? owner : null, expiresAt: Date.parse(result.expiresAt), notBefore };
        notify({ status: "ready" });
      } catch {
        if (same(version, owner)) notify({ status: "unavailable" });
      }
    }
    async function complete() {
      const i = identity();
      if (disposed || !pending || !enabled(i) || !(i.authenticated || i.cubeRun?.guestCheckout === true)) return null;
      if (pending.expiresAt <= now() || pending.owner !== null && pending.owner !== i.accountScope) {
        pending = null;
        clearSaved();
        return null;
      }
      pending.owner = i.accountScope;
      save();
      if (inflight) return inflight;
      const current = pending, owner = i.accountScope;
      inflight = (async () => {
        try {
          if (current.notBefore > now()) await wait(current.notBefore - now());
          if (disposed || pending !== current || identity()?.accountScope !== owner) return null;
          const result = await request("complete", { token: i.cubeRun.token, evidence: current.evidence });
          if (disposed || pending !== current || identity()?.accountScope !== owner) return null;
          pending = null;
          clearSaved();
          await notify({ status: result.eligible ? "checked" : "not_earned", runId: result.runId, pct: result.pct, check: result.check });
          return result;
        } catch (error) {
          if (pending === current && identity()?.accountScope === owner) notify({ status: "retry", runId: current.evidence.runId });
          return null;
        } finally {
          inflight = null;
        }
      })();
      return inflight;
    }
    async function event(e) {
      if (disposed || e.gameVersion !== VERSION) return;
      if (e.type === "challenge_requested") return issue();
      if (e.type === "run_started") {
        ++generation;
        engine.setChallenge(null);
        running = candidate && candidate.id === e.challengeId && candidate.expiresAt > now() ? { ...candidate, runId: e.runId } : null;
        candidate = null;
      }
      if (e.type === "run_completed") {
        const evidence = minimal(e);
        if (!running || !evidence || running.id !== e.challengeId || running.runId !== e.runId) return;
        pending = { evidence, owner: running.owner, expiresAt: running.expiresAt, notBefore: running.notBefore };
        running = null;
        save();
        if (!(identity()?.authenticated || identity()?.cubeRun?.guestCheckout === true)) {
          notify({ status: "sign_in" });
          return;
        }
        return complete();
      }
      if (e.type === "run_abandoned") running = null;
    }
    function accountChanged() {
      const next = identity()?.accountScope ?? null;
      if (scope !== next) {
        scope = next;
        ++generation;
        candidate = null;
        running = null;
        engine.setChallenge(null);
        if (pending?.owner !== null && pending?.owner !== next) {
          pending = null;
          clearSaved();
        }
      }
      return complete();
    }
    return {
      event,
      issue,
      complete,
      accountChanged,
      ready: () => !!candidate && candidate.expiresAt > now() + 18e4 && candidate.owner === (identity()?.accountScope ?? null),
      suspend() {
        ++generation;
        candidate = null;
        running = null;
        engine.setChallenge(null);
      },
      dispose() {
        disposed = true;
        ++generation;
        candidate = null;
        running = null;
        engine.setChallenge(null);
      }
    };
  }
  function createCubeChallengeTransport({ fetch: send, base = "/apps/dardasha-digital/", storage }) {
    const sessionKey = "dd-cube-session-v1";
    let sessionToken = null, establishing = null;
    try {
      sessionToken = storage?.getItem(sessionKey) || null;
    } catch {
    }
    async function post(endpoint, body) {
      const response = await send(base + "cube/" + endpoint, { method: "POST", credentials: "same-origin", cache: "no-store", redirect: "error", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body), signal: AbortSignal.timeout(1e4) });
      const result = await response.json();
      if (!response.ok) throw Object.assign(Error("Reward check unavailable"), { status: response.status });
      return result;
    }
    return async (endpoint, body) => {
      if (!sessionToken) {
        establishing ||= post("session", { token: body.token }).then((result) => {
          if (typeof result.sessionToken !== "string" || !/^(?:s1|g1)\.\d{13}\.[a-f0-9-]{36}\.[a-f0-9]{64}$/.test(result.sessionToken)) throw Error("Invalid session");
          sessionToken = result.sessionToken;
          try {
            storage?.setItem(sessionKey, sessionToken);
          } catch {
          }
        }).finally(() => {
          establishing = null;
        });
        await establishing;
      }
      return post(endpoint, { ...body, sessionToken });
    };
  }
  async function mountCubeChallengeBridge({ target, engine, storage, fetch: send, base = "/apps/dardasha-digital/", now, wait, notify, onProfile = () => {
  } }) {
    engine ||= { state: () => ({ screen: "none", runId: null }), setChallenge: () => true };
    if (!engine?.setChallenge || !engine?.state || !target?.addEventListener) throw Error("Game interface unavailable");
    let identity = null, bridge = null, revision = 0, disposed = false;
    const request = createCubeChallengeTransport({ fetch: send, base, storage });
    async function refresh(options = {}) {
      const version = ++revision;
      identity = null;
      onProfile(null);
      try {
        const r = await send(base + "profile", { credentials: "same-origin", cache: "no-store", redirect: "error", headers: { Accept: "application/json" }, signal: AbortSignal.timeout(1e4) });
        const p = await r.json();
        if (disposed || version !== revision) return;
        if (!r.ok || typeof p.authenticated !== "boolean" || typeof p.accountScope !== "string" || !p.accountScope) throw Error("Unverified account");
        identity = { authenticated: p.authenticated, accountScope: p.accountScope, cubeRun: p.cubeRun };
        onProfile(identity);
        if (!bridge) bridge = createCubeChallengeBridge({ engine, storage, request, identity: () => identity, now, wait, notify });
        await bridge.accountChanged();
        if (!disposed && version === revision) await bridge.issue(options);
      } catch {
        if (disposed || version !== revision) return;
        identity = null;
        await bridge?.accountChanged();
        onProfile(null);
      }
    }
    const event = (e) => {
      void bridge?.event(e.detail || {});
    };
    const profile = () => {
      void refresh();
    };
    target.addEventListener("dardasha:cube-run", event);
    target.addEventListener("dardasha:profile-state", profile);
    target.addEventListener("pageshow", profile);
    await refresh();
    return { refresh, ready: () => bridge?.ready() === true, prepareRun: async () => {
      await refresh({ forPlay: true });
      return bridge?.ready() === true;
    }, complete: () => bridge?.complete(), dispose() {
      disposed = true;
      ++revision;
      bridge?.dispose();
      target.removeEventListener("dardasha:cube-run", event);
      target.removeEventListener("dardasha:profile-state", profile);
      target.removeEventListener("pageshow", profile);
    } };
  }

  // website/assets/dd-cube-cart.mjs
  var uuid3 = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  var outcome = (status, reason, pct = 0) => ({ status, reason, pct, gift: "none" });
  function applications(cart) {
    return [...cart.cart_level_discount_applications || [], ...cart.items.flatMap((i) => (i.line_level_discount_allocations || []).map((a) => a.discount_application))].filter(Boolean);
  }
  function signature(item) {
    return JSON.stringify([String(item.variant_id), item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  }
  function quantities(items) {
    const result = /* @__PURE__ */ new Map();
    for (const item of items) result.set(signature(item), (result.get(signature(item)) || 0) + item.quantity);
    return result;
  }
  function applied(line, offer) {
    return (line.line_level_discount_allocations || []).some((a) => a.amount > 0 && a.discount_application?.type === "discount_code" && [offer.code, `Cube Run ${offer.pct}% ${offer.claimId}`].includes(a.discount_application.title) && a.discount_application.value_type === "percentage" && Number(a.discount_application.value) === offer.pct);
  }
  async function applyCubeRewardCart(deps, offer) {
    if (!deps.enabled()) return outcome("not_eligible", "inactive");
    if (!offer || !uuid3.test(offer.claimId) || !Number.isSafeInteger(offer.variantId) || offer.variantId < 1 || ![10, 15, 20].includes(offer.pct) || !/^(?:DDCR[A-F0-9]{40}|CUBERUN(?:10|15|20)-[A-HJ-NP-Z2-9]{16})$/.test(offer.code) || /^CUBERUN/.test(offer.code) && !offer.code.startsWith(`CUBERUN${offer.pct}-`) || !/^[a-f0-9]{64}$/.test(offer.accountScope) || typeof offer.contextId !== "string" || !offer.contextId || offer.contextId.length > 160 || !Number.isFinite(Date.parse(offer.expiresAt))) return outcome("error", "invalid_offer");
    const replaceable = offer.replaceable || [];
    if (!Array.isArray(replaceable) || replaceable.length > 5 || replaceable.some((r) => !r || !uuid3.test(r.claimId) || ![10, 15].includes(r.pct) || r.pct >= offer.pct || !/^[a-f0-9]{64}$/.test(r.codeHash))) return outcome("error", "invalid_offer");
    async function permits(application) {
      if (application.type !== "discount_code" || [offer.code, `Cube Run ${offer.pct}% ${offer.claimId}`].includes(application.title)) return true;
      if (typeof application.title !== "string") return false;
      const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(application.title.toUpperCase()));
      const hash = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
      return replaceable.some((r) => Number(application.value) === r.pct && (hash === r.codeHash || application.title === `Cube Run ${r.pct}% ${r.claimId}`));
    }
    const incompatible = async (cart) => (await Promise.all(applications(cart).map(permits))).some((ok) => !ok);
    if (!deps.locks?.request || !deps.journal?.get || !deps.journal?.set) return outcome("error", "recovery_unavailable");
    if (!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(deps.root)) return outcome("error", "invalid_route");
    const current = () => {
      const a = deps.identity();
      return a?.accountScope === offer.accountScope && a?.contextId === offer.contextId;
    };
    const valid = () => current() && Date.parse(offer.expiresAt) > (deps.now?.() ?? Date.now());
    const key = `dd-cube-cart:${offer.accountScope}:${offer.claimId}`;
    return deps.locks.request("dd-cube-reward-cart", { mode: "exclusive" }, async () => {
      let wrote = false;
      const request = async (path, body) => {
        if (!valid()) throw new Error("stale");
        const response = await deps.fetch(deps.root + path, { method: body ? "POST" : "GET", credentials: "same-origin", cache: "no-store", signal: deps.signal, headers: body ? { "Content-Type": "application/json" } : {}, ...body ? { body: JSON.stringify(body) } : {} });
        if (!response.ok) throw new Error("request");
        return response.json();
      };
      const read = async () => {
        const cart = await request("cart.js");
        if (!Array.isArray(cart?.items) || cart.items.length > 1e3 || cart.items.some((i) => !Number.isSafeInteger(i.quantity) || i.quantity < 1)) throw new Error("cart");
        return cart;
      };
      try {
        if (!valid()) return outcome("not_eligible", "account_or_expiry");
        let cart = await read();
        if (!valid()) return outcome("not_eligible", "account_or_expiry");
        if (await incompatible(cart)) return outcome("not_eligible", "existing_discount");
        const upgrading = cart.items.filter((i) => replaceable.some((r) => r.claimId === i.properties?._dd_cube_claim));
        if (upgrading.length > 1 || upgrading.some((i) => String(i.variant_id) !== String(offer.variantId) || i.quantity !== 1 || i.selling_plan_allocation || typeof i.key !== "string" || i.key.length > 200)) return outcome("partial", "cart_changed");
        const before = quantities(cart.items.filter((i) => i.properties?._dd_cube_claim !== offer.claimId && !upgrading.includes(i)));
        let lines = cart.items.filter((i) => i.properties?._dd_cube_claim === offer.claimId);
        if (lines.length && upgrading.length) return outcome("partial", "cart_changed");
        let journal = await deps.journal.get(key);
        if (!lines.length && journal?.stage === "done" && offer.restoreRemoved === true) journal = null;
        if (journal && journal.variantId !== offer.variantId) return outcome("error", "recovery_conflict");
        if (lines.length > 1 || lines.some((i) => String(i.variant_id) !== String(offer.variantId) || i.quantity !== 1 || i.selling_plan_allocation)) return outcome("partial", "cart_changed");
        if (!lines.length && upgrading.length === 1 && !journal) {
          await deps.journal.set(key, { variantId: offer.variantId, stage: "changing" });
          wrote = true;
          await request("cart/change.js", { id: upgrading[0].key, quantity: 1, properties: { ...upgrading[0].properties, _dd_cube_claim: offer.claimId } });
          cart = await read();
          lines = cart.items.filter((i) => i.properties?._dd_cube_claim === offer.claimId);
          if (!lines.length) return outcome("pending", "reconcile_cart");
        }
        if (!lines.length) {
          if (journal) return outcome("pending", journal.stage === "done" ? "item_removed" : "reconcile_cart");
          await deps.journal.set(key, { variantId: offer.variantId, stage: "adding" });
          wrote = true;
          await request("cart/add.js", { items: [{ id: offer.variantId, quantity: 1, properties: { _dd_cube_claim: offer.claimId } }] });
          cart = await read();
          lines = cart.items.filter((i) => i.properties?._dd_cube_claim === offer.claimId);
        }
        if (!valid()) return outcome("pending", "account_or_expiry");
        if (lines.length !== 1 || lines[0].quantity !== 1 || String(lines[0].variant_id) !== String(offer.variantId)) return outcome("pending", "reconcile_cart");
        if (await incompatible(cart)) return outcome("partial", "existing_discount");
        await deps.journal.set(key, { variantId: offer.variantId, stage: "applying" });
        wrote = true;
        if (!applied(lines[0], offer)) await request("cart/update.js", { discount: offer.code });
        cart = await read();
        if (!valid()) return outcome("pending", "account_or_expiry");
        lines = cart.items.filter((i) => i.properties?._dd_cube_claim === offer.claimId);
        const after = quantities(cart.items.filter((i) => i.properties?._dd_cube_claim !== offer.claimId));
        if ([...before].some(([id, n]) => (after.get(id) || 0) < n)) return outcome("partial", "cart_changed");
        if (lines.length !== 1 || lines[0].quantity !== 1 || String(lines[0].variant_id) !== String(offer.variantId) || !applied(lines[0], offer)) return outcome("partial", "discount_not_confirmed");
        await deps.journal.set(key, { variantId: offer.variantId, stage: "done" });
        return outcome("added", "verified_cart", offer.pct);
      } catch {
        return outcome(wrote ? "pending" : "error", "reconcile_cart");
      }
    });
  }

  // website/assets/dd-cube-checkout.mjs
  var uuid4 = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  function createCubeCheckoutController({ engine, identity, enabled, checkout, cart, ensureCompleted = async () => {
  }, signIn = () => {
  }, storage, uid = () => crypto.randomUUID(), root = "/" }) {
    if (!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(root)) throw Error("Invalid cart route");
    let disposed = false, revision = 0, owner = identity()?.accountScope ?? null, context = uid();
    const requests = /* @__PURE__ */ new Map(), inflight = /* @__PURE__ */ new Map();
    engine.setContext(context);
    const active = () => enabled() && identity()?.cubeRun?.commerceEnabled === true;
    function current(d, rev, scope) {
      const i = identity(), s = engine.state(), waiting = engine.cartState();
      return !disposed && revision === rev && active() && (i?.authenticated || i?.cubeRun?.guestCheckout === true) && i.accountScope === scope && s.runId === d.runId && d.contextId === context && waiting.busy && waiting.runId === d.runId && waiting.attemptId === d.attemptId && waiting.contextId === context;
    }
    const echo = (d, claimId) => ({ runId: d.runId, attemptId: d.attemptId, claimId, contextId: d.contextId, experience: d.experience });
    const deliver = (d, claimId, result) => engine.cartResult({ ...echo(d, claimId), ...result });
    function requestId(scope, runId) {
      const key = `dd-cube-checkout-request:${scope}:${runId}`;
      if (requests.has(key)) return requests.get(key);
      let id;
      try {
        id = storage?.getItem(key);
      } catch {
      }
      if (!uuid4.test(id || "")) id = uid();
      if (!storage?.setItem) throw Error("storage");
      storage.setItem(key, id);
      requests.set(key, id);
      return id;
    }
    async function perform(d) {
      const i = identity(), rev = revision, scope = i?.accountScope;
      if (!(i?.authenticated || i?.cubeRun?.guestCheckout === true)) {
        deliver(d, d.retryOf && uuid4.test(d.retryOf) ? d.retryOf : void 0, { status: "not_eligible", reason: "sign_in_required", pct: 0, gift: "none" });
        return;
      }
      if (!current(d, rev, scope)) return;
      let claimId = d.retryOf && uuid4.test(d.retryOf) ? d.retryOf : void 0;
      try {
        const id = requestId(scope, d.runId);
        await ensureCompleted();
        if (!current(d, rev, scope)) return;
        const key = `${scope}:${d.runId}`;
        let resultPromise = inflight.get(key);
        if (!resultPromise) {
          resultPromise = Promise.resolve(checkout({ token: identity()?.cubeRun?.checkoutToken, runId: d.runId, requestId: id }));
          inflight.set(key, resultPromise);
          resultPromise.finally(() => {
            if (inflight.get(key) === resultPromise) inflight.delete(key);
          }).catch(() => {
          });
        }
        const response = await resultPromise;
        if (!current(d, rev, scope)) return;
        if (response.claimId) {
          if (!uuid4.test(response.claimId) || claimId && claimId !== response.claimId) throw Error("claim_conflict");
          claimId = response.claimId;
        }
        if (!claimId || !engine.cartPending(echo(d, claimId))) return;
        if (response.status !== "prepared" || !response.offer) {
          deliver(d, claimId, { status: "pending", reason: "pending", pct: 0, gift: "none" });
          return;
        }
        const offer = response.offer;
        if (offer.claimId !== claimId || offer.accountScope !== scope) throw Error("identity");
        const result = await applyCubeRewardCart({ ...cart, root, enabled: () => current(d, rev, scope), identity: () => ({ accountScope: identity()?.accountScope, contextId: context }) }, { ...offer, contextId: context });
        if (!current(d, rev, scope)) return;
        const reason = { existing_discount: "incompatible_discount", discount_not_confirmed: "cart_partial", cart_changed: "cart_partial", reconcile_cart: "pending", item_removed: "cart_partial", account_or_expiry: "expired" }[result.reason] || (result.status === "added" ? "other" : "pending");
        const gift = result.status === "added" ? { reserved: "added", already_claimed: "already_claimed", unavailable: "unavailable" }[response.gift] || "none" : "none";
        deliver(d, claimId, { status: result.status, reason, pct: result.pct, gift, cartUrl: root + "cart", expiresAt: offer.expiresAt });
      } catch (error) {
        if (current(d, rev, scope)) {
          if (error?.claimId && uuid4.test(error.claimId)) claimId = error.claimId;
          if (claimId && !engine.cartPending(echo(d, claimId))) return;
          deliver(d, claimId, { status: error?.status === 401 ? "not_eligible" : claimId ? "pending" : "error", reason: error?.status === 401 ? "sign_in_required" : "pending", pct: 0, gift: "none" });
        }
      }
    }
    function event(e) {
      const d = e.detail;
      if (disposed || !active() || !d?.compatibleWith?.includes(2) || d.mode !== "live") return;
      if (d.type === "sign_in_requested" && d.contextId === context && d.runId === engine.state().runId) {
        e.preventDefault();
        return Promise.resolve(signIn());
      }
      if (d.type !== "cart_requested") return;
      if (!uuid4.test(d.runId || "") || typeof d.attemptId !== "string" || d.contextId !== context || !["shop", "library"].includes(d.experience)) return;
      e.preventDefault();
      return perform(d);
    }
    return { event, accountChanged() {
      const next = identity()?.accountScope ?? null;
      if (next !== owner) {
        owner = next;
        ++revision;
        context = uid();
        engine.setContext(context);
      }
    }, dispose() {
      disposed = true;
      ++revision;
      engine.cartReset({ reason: "website_disposed" });
    }, context: () => context };
  }

  // website/assets/dd-cube-commerce.mjs
  var uuid5 = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  async function mountCubeCommerce({ target, document: document2, engine, sessionStorage, durableStorage, fetch: rawSend, locks, diagnostics = false, root = "/", signIn, base = "/apps/dardasha-digital/" }) {
    if (!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(root)) throw Error("Invalid cart route");
    const diagnostic = mountCubeDiagnostics({ document: document2, engine, enabled: diagnostics });
    const send = async (url, init) => {
      const response = await rawSend(url, init);
      if (diagnostics) {
        let body;
        try {
          body = await response.clone().json();
        } catch {
        }
        diagnostic.response(url, response.status, body);
      }
      return response;
    };
    let profile = null, controller = null, pass = null, needsRefresh = false, disposed = false, generation = 0, context = crypto.randomUUID(), busy = false, verifiedOwner = null;
    const ar = document2.documentElement.lang?.startsWith("ar"), t = (en, arabic) => ar ? arabic : en;
    const host = document2.querySelector("[data-dd-library]") || document2.getElementById("cuberun");
    const panel = host ? document2.createElement("section") : null;
    if (panel) {
      panel.className = "dd-panel dd-cube-recovery";
      panel.hidden = true;
      panel.setAttribute("aria-live", "polite");
      host.after(panel);
    }
    const journal = { get: async (k) => {
      const raw = durableStorage.getItem(k);
      return raw ? JSON.parse(raw) : null;
    }, set: async (k, v) => durableStorage.setItem(k, JSON.stringify(v)) };
    const cart = { fetch: send, locks, journal };
    async function checkout(body) {
      const r = await send(base + "cube/checkout", { method: "POST", credentials: "same-origin", cache: "no-store", redirect: "error", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify(body), signal: AbortSignal.timeout(1e4) });
      const result = await r.json();
      if (!r.ok) throw Object.assign(Error("Reward checkout unavailable"), { status: r.status, claimId: result.claimId });
      return result;
    }
    const isCurrent = (version, owner) => !disposed && generation === version && profile?.accountScope === owner && (profile?.authenticated || profile?.cubeRun?.guestCheckout === true) && profile.cubeRun?.commerceEnabled === true;
    async function redeem(runId, status, button) {
      if (busy || !uuid5.test(runId) || !(profile?.authenticated || profile?.cubeRun?.guestCheckout === true) || profile.cubeRun?.commerceEnabled !== true) return;
      const version = generation, owner = profile.accountScope, operationContext = context;
      busy = true;
      button.disabled = true;
      status.textContent = t("Checking your reward\u2026", "\u0646\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0645\u0643\u0627\u0641\u0623\u062A\u0643\u0645\u2026");
      try {
        const key = `dd-cube-checkout-request:${owner}:${runId}`;
        let requestId = durableStorage.getItem(key);
        if (!uuid5.test(requestId || "")) requestId = crypto.randomUUID();
        durableStorage.setItem(key, requestId);
        const response = await checkout({ token: profile.cubeRun.checkoutToken, runId, requestId });
        if (!isCurrent(version, owner)) return;
        if (response.status !== "prepared" || !response.offer || response.offer.accountScope !== owner || response.offer.claimId !== response.claimId) throw Error("unverified_offer");
        const result = await applyCubeRewardCart({ ...cart, root, enabled: () => isCurrent(version, owner), identity: () => ({ accountScope: profile?.accountScope, contextId: context }) }, { ...response.offer, contextId: operationContext });
        if (!isCurrent(version, owner)) return;
        if (result.status === "added") {
          status.textContent = response.gift === "reserved" ? t("Your cubes are in your cart with your discount. A free figurines set is reserved for this reward and will be included after your qualifying order is paid and confirmed.", "\u0627\u0644\u0645\u0643\u0639\u0651\u0628\u0627\u062A \u0641\u064A \u0633\u0644\u0651\u062A\u0643\u0645 \u0645\u0639 \u0627\u0644\u062E\u0635\u0645. \u062D\u064F\u062C\u0650\u0632\u062A \u0644\u0643\u0645 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062C\u0633\u0651\u0645\u0627\u062A \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0651\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629\u060C \u0648\u0633\u062A\u064F\u0631\u0641\u064E\u0642 \u0628\u0637\u0644\u0628\u0643\u0645 \u0628\u0639\u062F \u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647.") : t("Your cubes are in your cart with your discount.", "\u0627\u0644\u0645\u0643\u0639\u0651\u0628\u0627\u062A \u0641\u064A \u0633\u0644\u0651\u062A\u0643\u0645 \u0645\u0639 \u0627\u0644\u062E\u0635\u0645.");
          const link = document2.createElement("a");
          link.className = "dd-btn";
          link.href = root + "cart";
          link.textContent = t("Go to cart", "\u0625\u0644\u0649 \u0627\u0644\u0633\u0644\u0651\u0629");
          button.replaceWith(link);
        } else {
          status.textContent = result.reason === "existing_discount" ? t("Your cart already has another offer. Review it before using this reward.", "\u0641\u064A \u0633\u0644\u0651\u062A\u0643\u0645 \u0639\u0631\u0636 \u0622\u062E\u0631. \u0631\u0627\u062C\u0639\u0648\u0647 \u0642\u0628\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629.") : t("Please check your cart, then retry the same reward.", "\u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0633\u0644\u0651\u0629\u060C \u062B\u0645\u0651 \u0625\u0639\u0627\u062F\u0629 \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629 \u0646\u0641\u0633\u0647\u0627.");
          button.disabled = false;
        }
      } catch {
        if (isCurrent(version, owner)) {
          status.textContent = t("We could not finish checking. Review your cart, then retry this reward.", "\u0644\u0645 \u0646\u062A\u0645\u0643\u0651\u0646 \u0645\u0646 \u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062A\u062D\u0642\u0651\u0642. \u0631\u0627\u062C\u0639\u0648\u0627 \u0627\u0644\u0633\u0644\u0651\u0629\u060C \u062B\u0645\u0651 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.");
          button.disabled = false;
        }
      } finally {
        if (generation === version) busy = false;
      }
    }
    function render() {
      if (!panel) return;
      panel.replaceChildren();
      const rewards = (profile?.authenticated || profile?.cubeRun?.guestCheckout === true) && profile.cubeRun?.commerceEnabled ? profile.cubeRun.activeRewards : [];
      if (!Array.isArray(rewards) || !rewards.length) {
        panel.hidden = true;
        return;
      }
      panel.hidden = false;
      const h = document2.createElement("h2");
      h.textContent = t("Your Cube Run rewards", "\u0645\u0643\u0627\u0641\u0622\u062A \u0633\u0628\u0627\u0642 \u0627\u0644\u0645\u0643\u0639\u0651\u0628\u0627\u062A");
      panel.append(h);
      for (const r of rewards.slice(0, 5)) {
        if (!uuid5.test(r.runId || "") || ![10, 15, 20].includes(r.pct) || !Number.isFinite(Date.parse(r.expiresAt)) || Date.parse(r.expiresAt) <= Date.now()) continue;
        const row = document2.createElement("div"), label = document2.createElement("p"), status = document2.createElement("p"), button = document2.createElement("button");
        label.textContent = t(`${r.pct}% off your wooden cubes`, `\u062E\u0635\u0645 ${r.pct}\u066A \u0639\u0644\u0649 \u0627\u0644\u0645\u0643\u0639\u0651\u0628\u0627\u062A \u0627\u0644\u062E\u0634\u0628\u064A\u0651\u0629`);
        button.className = "dd-btn";
        button.type = "button";
        button.textContent = t("Use this reward", "\u0627\u0633\u062A\u062E\u062F\u0645\u0648\u0627 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629");
        button.onclick = () => {
          void redeem(r.runId, status, button);
        };
        row.append(label, button, status);
        panel.append(row);
      }
    }
    pass = await mountCubeChallengeBridge({
      target,
      engine,
      storage: sessionStorage,
      fetch: send,
      base,
      onProfile(next) {
        if (next && verifiedOwner !== next.accountScope) {
          verifiedOwner = next.accountScope;
          ++generation;
          context = crypto.randomUUID();
          busy = false;
        }
        profile = next;
        diagnostic.profile(next);
        if (next) controller?.accountChanged();
        if (engine && next?.cubeRun?.challengeEnabled) engine.configure({ giftAvailable: next.cubeRun.giftAvailable === true });
        render();
      },
      notify(result) {
        if (result.status === "checked") {
          if (pass) return pass.refresh();
          needsRefresh = true;
        }
      }
    });
    if (engine) controller = createCubeCheckoutController({ engine, identity: () => profile, enabled: () => !disposed && profile?.cubeRun?.commerceEnabled === true, checkout, cart, root, storage: durableStorage, signIn, ensureCompleted: () => pass.complete() });
    const signInEvent = (e) => {
      if (e.detail?.type === "sign_in_requested") void controller?.event(e);
    };
    target.addEventListener("dardasha:cube-run", signInEvent);
    if (needsRefresh) await pass.refresh();
    return {
      handleEvent(e) {
        if (!controller || e.detail?.type !== "cart_requested") return false;
        const result = controller.event(e);
        if (!result) return false;
        void result.catch(() => {
        });
        return true;
      },
      ready: () => profile?.cubeRun?.guestCheckout === true && pass.ready(),
      prepareRun: () => pass.prepareRun(),
      refresh: () => pass.refresh(),
      dispose() {
        disposed = true;
        ++generation;
        controller?.dispose();
        pass.dispose();
        diagnostic.dispose();
        target.removeEventListener("dardasha:cube-run", signInEvent);
        panel?.remove();
      }
    };
  }

  // website/assets/dd-cube-cart-label.mjs
  var renderedNodes = /* @__PURE__ */ new WeakMap();
  var rewardCode = /^(?:DDCR[A-F0-9]{40}|CUBERUN(?:10|15|20)-[A-HJ-NP-Z2-9]{16})$/;
  function cubeCartRewardLabels(cart, arabic = false) {
    const labels = /* @__PURE__ */ new Map();
    for (const item of cart?.items || []) for (const allocation of item.line_level_discount_allocations || []) {
      const app = allocation.discount_application, pct = Number(app?.value);
      if (allocation.amount > 0 && app?.type === "discount_code" && rewardCode.test(app.title || "") && app.value_type === "percentage" && [10, 15, 20].includes(pct))
        labels.set(app.title, arabic ? `\u0645\u0643\u0627\u0641\u0623\u0629 Cube Run \xB7 \u062E\u0635\u0645 ${String(pct).replace(/[0-9]/g, (d) => "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669"[Number(d)])}\u066A` : `Cube Run reward \xB7 ${pct}% off`);
    }
    return labels;
  }
  function replaceCubeCartRewardLabels(document2, labels = /* @__PURE__ */ new Map()) {
    const arabic = document2.documentElement.lang?.startsWith("ar");
    let changed = 0;
    for (const element of document2.querySelectorAll(".discounts__discount")) for (const node of element.childNodes) {
      if (node.nodeType !== 3) continue;
      const raw = node.textContent.trim();
      let code = renderedNodes.get(node);
      if (rewardCode.test(raw)) {
        code = raw;
        renderedNodes.set(node, code);
      } else if (!code || !/^(Cube Run reward|مكافأة Cube Run)/.test(raw)) {
        renderedNodes.delete(node);
        continue;
      }
      const label = labels.get(code) || (arabic ? "\u0645\u0643\u0627\u0641\u0623\u0629 Cube Run" : "Cube Run reward");
      if (node.textContent !== label) {
        node.textContent = label;
        changed++;
      }
    }
    return changed;
  }
  function mountCubeCartRewardLabels({ document: document2, fetch: send, MutationObserver, root = "/" }) {
    if (!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(root)) return;
    let labels = /* @__PURE__ */ new Map(), busy = false;
    const render = () => replaceCubeCartRewardLabels(document2, labels);
    const refresh = async () => {
      if (busy || !document2.querySelector(".discounts__discount")) return;
      busy = true;
      try {
        const r = await send(root + "cart.js", { credentials: "same-origin", cache: "no-store", redirect: "error" });
        if (r.ok) labels = cubeCartRewardLabels(await r.json(), document2.documentElement.lang?.startsWith("ar"));
      } catch {
      } finally {
        busy = false;
        render();
      }
    };
    const observer = new MutationObserver((records) => {
      if (records.some((r) => r.type === "childList" && r.addedNodes.length)) render();
    });
    observer.observe(document2.body, { childList: true, subtree: true });
    void refresh();
    return { refresh, dispose: () => observer.disconnect() };
  }

  // website/assets/dd-cube-commerce-entry.mjs
  if (document.getElementById("cuberun")) {
    const style = document.createElement("style");
    style.dataset.ddCubeCompatibility = "true";
    style.textContent = dd_cube_compat_default;
    document.head.append(style);
  }
  (async () => {
    if (window.DardashaCubeCommerce || !window.CubeRun && !document.querySelector("[data-dd-library]")) return;
    const cfg = JSON.parse(document.getElementById("dd-digital-config")?.textContent || "{}");
    const root = (cfg.root || "/").replace(/\/?$/, "/");
    const signIn = () => {
      const url = new URL(window.DardashaDigital.accountUrl()), origin = new URL(cfg.storeOrigin || "https://dardasha.com");
      if (url.protocol !== "https:" || url.origin !== origin.origin) throw Error("Invalid sign-in route");
      window.location.assign(url.href);
    };
    const shop = isCubeShopPage({ pathname: window.location?.pathname, experience: window.CubeRun?.contract?.experience });
    const shopStorage = cubeShopStorage(window.localStorage);
    const send = shop ? createCubeShopTransport({ fetch: window.fetch.bind(window), storage: shopStorage }) : window.fetch.bind(window);
    let commerceReady;
    if (shop) mountCubeShopStartGuard({ document, ready: () => window.DardashaCubeCommerce?.ready?.() === true, prepare: async () => {
      const mounted = await commerceReady;
      return mounted.prepareRun();
    } });
    commerceReady = mountCubeCommerce({ target: window, document, engine: window.CubeRun, sessionStorage: shop ? shopStorage : window.sessionStorage, durableStorage: window.localStorage, fetch: send, locks: navigator.locks, diagnostics: /(?:^|[?&])cube_diagnostics=1(?:&|$)/.test(window.location?.search || ""), root, signIn });
    window.DardashaCubeCommerce = await commerceReady;
  })().catch(() => {
  });
  var cartNotice = document.querySelector("[data-dd-cube-cart-notice]");
  if (cartNotice && !window.DardashaCubeCartNotice) {
    window.DardashaCubeCartNotice = mountCubeCartGift({ document, target: window, node: cartNotice, fetch: createCubeCartNoticeTransport(window.fetch.bind(window), window.localStorage), MutationObserver: window.MutationObserver, setTimeout, clearTimeout, css: dd_cube_cart_gift_default });
  }
  if (!window.DardashaCubeCartLabels && typeof window.MutationObserver === "function") {
    const root = document.querySelector("[data-dd-cube-cart-notice]")?.dataset.root || "/";
    window.DardashaCubeCartLabels = mountCubeCartRewardLabels({ document, fetch: window.fetch.bind(window), MutationObserver: window.MutationObserver, root });
    const refresh = () => {
      void window.DardashaCubeCartLabels?.refresh();
    };
    window.addEventListener("pageshow", refresh);
    window.addEventListener("focus", refresh);
    document.addEventListener("change", refresh);
  }
})();


/* Shop cart display and gift bow, website-only. */
(()=>{
/* Website-only presentation: never adds products, creates claims or applies codes. */
async function refreshCubeShopCart({document,fetch:send,root='/',DOMParser}){
 if(!/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(root))throw Error('Invalid route');
 const request=async url=>{const r=await send(url,{method:'GET',credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});if(!r.ok)throw Error('Cart display unavailable');return r.json();};
 const [cart,sections]=await Promise.all([request(root+'cart.js'),request(root+'?sections=cart-drawer,cart-icon-bubble')]);
 if(!Number.isSafeInteger(cart.item_count)||cart.item_count<0)throw Error('Invalid cart display');
 const updates=[];
 for(const [name,targetSelector,sourceSelector] of [['cart-icon-bubble','#cart-icon-bubble','.shopify-section'],['cart-drawer','#CartDrawer','#CartDrawer']]){
  const target=document.querySelector(targetSelector);if(!target)continue;
  if(typeof sections?.[name]!=='string')throw Error('Missing cart section');
  const source=new DOMParser().parseFromString(sections[name],'text/html').querySelector(sourceSelector);if(!source)throw Error('Invalid cart section');
  updates.push([target,source.innerHTML]);
 }
 for(const [target,html]of updates)target.innerHTML=html;
 const drawer=document.querySelector('cart-drawer');
 if(drawer){drawer.classList.toggle('is-empty',cart.item_count===0);drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close?.());}
 return {itemCount:cart.item_count};
}

function mountCubeShopCartUI({target,document,engine,fetch:send,root='/',DOMParser}){
 let flight=null,disposed=false;
 const refresh=()=>{if(!flight){flight=refreshCubeShopCart({document,fetch:send,root,DOMParser}).finally(()=>{flight=null;});}return flight;};
 function decorate(detail){
  const view=document.querySelector('#cuberun #goCart');if(!view)return;
  const ar=(detail.lang||document.documentElement.lang||'').startsWith('ar');
  view.textContent=ar?'عرض السلّة':'View cart';
  if(document.querySelector('#cuberun [data-dd-continue-shopping]'))return;
  const button=document.createElement('button');button.type='button';button.className='cta purple';button.dataset.ddContinueShopping='';button.textContent=ar?'متابعة التسوّق':'Continue shopping';
  button.addEventListener('click',async()=>{
   if(document.fullscreenElement&&document.getElementById('cuberun')?.contains(document.fullscreenElement)){try{await document.exitFullscreen();}catch{}}
   const heading=document.querySelector('.product__title h1')||document.querySelector('main h1');
   if(heading){heading.scrollIntoView({behavior:target.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});heading.tabIndex=-1;heading.focus({preventScroll:true});}
  });view.parentElement.append(button);
 }
 function event(e){
  const d=e.detail;if(disposed||d?.type!=='cart_result_shown'||d.mode!=='live'||d.experience!=='shop'||!['added','partial'].includes(d.status)||!d.compatibleWith?.includes(2)||engine.state().runId!==d.runId)return;
  if(d.status==='added')decorate(d);
  // A display refresh must never turn a confirmed reward into a retry/add operation.
  void refresh().catch(()=>{});
 }
 target.addEventListener('dardasha:cube-run',event);
 return{dispose(){disposed=true;target.removeEventListener('dardasha:cube-run',event);}};
}

const shopPage=/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/wooden-alphabet-cubes\/?$/i.test(location.pathname);
if(shopPage&&window.CubeRun?.contract?.experience==='shop'&&!window.DardashaCubeShopCartUI){
 let config={};try{config=JSON.parse(document.getElementById('dd-digital-config')?.textContent||'{}');}catch{}
 const style=document.createElement('style');style.dataset.ddCubeShopUi='true';style.textContent="/* Joined bow, attached to the existing animated gift lid. */\n#cuberun #box .bow{top:-24px;width:76px;height:30px;background:radial-gradient(ellipse 10px 7px at 50% 23px,var(--carrot) 96%,transparent 100%)}\n#cuberun #box .bow::before,#cuberun #box .bow::after{box-sizing:border-box;top:0;width:40px;height:28px;border:7px solid var(--carrot);border-radius:60% 60% 45% 45%}\n#cuberun #box .bow::before{left:2px;transform:rotate(25deg);transform-origin:85% 85%}\n#cuberun #box .bow::after{right:2px;transform:rotate(-25deg);transform-origin:15% 85%}\n";document.head.append(style);
 window.DardashaCubeShopCartUI=mountCubeShopCartUI({target:window,document,engine:window.CubeRun,fetch:window.fetch.bind(window),root:(config.root||'/').replace(/\/?$/,'/'),DOMParser:window.DOMParser});
}
})();
